import {createFeatureSelector, createSelector} from '@ngrx/store';
import {State} from './dvr.delete-many.reducer';
import {DvrRecord} from '../../../services/api/dvr/dvr.model';

export const deleteManyDvrFeatureKey = 'deleteManyDVRs';
export const featureSelector = createFeatureSelector<State>(deleteManyDvrFeatureKey);

export const getDeleteManyDvrRecord = createSelector(
  featureSelector,
  (state: State): DvrRecord[] => state.record
);

export const getDeleteManyDvrLoaded = createSelector(
  featureSelector,
  (state: State): boolean => state.loaded
);

export const getDeleteManyDvrLoading = createSelector(
  featureSelector,
  (state: State): boolean => state.loading
);

export const getDeleteManyDvrError = createSelector(
  featureSelector,
  (state: State): any => state.error
);
